import type { AprisionamentoCenario } from '../../dominio/didatico/cenariosExtracao'
import type { ColocacaoVitima } from '../../dominio/didatico/rigVitima'
import type { ProporcoesVitima } from '../../dominio/didatico/perfisVitima'
import { Rotulo3D } from '../componentes/Rotulo3D'

interface Props {
  colocacao: ColocacaoVitima
  proporcoes: ProporcoesVitima
  aprisionamentos: readonly AprisionamentoCenario[]
}

const posicaoLocal = (tipo: AprisionamentoCenario['tipo'], proporcoes: ProporcoesVitima): [number, number, number] => {
  const perna = proporcoes.alturaPelve * 0.55
  switch (tipo) {
    case 'painel': return [-0.16, -perna * 0.55, -0.48]
    case 'pedais': return [-0.16, -perna, -0.68]
    case 'colunaB': return [-proporcoes.larguraOmbros * 0.58, 0.38, 0.22]
    case 'bancoCinto': return [0, 0.28, 0.02]
    case 'deformacao': return [proporcoes.larguraOmbros * 0.55, 0.16, -0.12]
  }
}

/** Marcadores geométricos, não diagnósticos, de por que o corpo não sai livremente. */
export function MarcadoresAprisionamento({ colocacao, proporcoes, aprisionamentos }: Props) {
  if (aprisionamentos.length === 0) return null
  return (
    <group
      position={[colocacao.posicaoPelve.x, colocacao.posicaoPelve.y, colocacao.posicaoPelve.z]}
      rotation={[0, colocacao.guinadaRad, 0]}
    >
      {aprisionamentos.map((item) => {
        const posicao = posicaoLocal(item.tipo, proporcoes)
        return (
          <group key={`${item.tipo}-${item.descricao}`} position={posicao}>
            <mesh>
              <sphereGeometry args={[0.1, 16, 12]} />
              <meshStandardMaterial color="#d56454" emissive="#d56454" emissiveIntensity={0.45} transparent opacity={0.82} />
            </mesh>
            <mesh rotation={[Math.PI / 2, 0, 0]}>
              <torusGeometry args={[0.16, 0.018, 8, 28]} />
              <meshBasicMaterial color="#f3b36b" />
            </mesh>
            <Rotulo3D posicao={{ x: 0, y: 0.25, z: 0 }} texto={item.descricao} variante="risco" fator={4.2} />
          </group>
        )
      })}
    </group>
  )
}
